document.addEventListener("DOMContentLoaded", function(){
//recipe page banner
if (document.querySelector('.image-with-text-overlay-container')) {
  new Splide('.image-with-text-overlay-container', {
    pagination: true,
    arrows: false,
    type: 'loop',
    speed: 500,
    autoHeight: true,
  }).mount();
}
//community learn-connect-nourish
if(window.innerWidth <= 990 && document.querySelector('.content-main-container')){
  new Splide('.content-main-container', {
    type: 'slide',
    arrows: false,
    pagination: true,
    speed: 500,
    perPage: 1.5,
    perMove: 1,
  }).mount();
}
document.querySelectorAll('.content-button__link, .overlay_link').forEach((el) => {
  el.addEventListener('click', (e) => {
    e.preventDefault();
    const target = document.querySelector('.join-us-form');
    if (target) {
      const top = target.getBoundingClientRect().top + window.pageYOffset - 150;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  });
});
//community--spotlight
if (document.querySelector('.community-card-slider')) {
  new Splide('.community-card-slider', {
    type: 'slide',
    arrows: false,
    pagination: true,
    speed: 500,
    perPage: 2.5,
    perMove: 1,
    breakpoints: {
      768: {
        perPage: 1.5,
        perMove: 1,
      }
    }
  }).mount();
}
//recipe page cards
if (document.querySelector('.cards--container')) {
  new Splide('.cards--container', {
    type: 'slide',
    arrows: false,
    pagination: false,
    speed: 500,
    perPage: 4.5,
    perMove: 1,
    breakpoints: {
      768: {
        perPage: 2.5,
        perMove: 1,
      }
    }
  }).mount();
}
// blog-home-custom.liquid
if (document.querySelector('.slider_wrap_blog')) {
  new Splide('.slider_wrap_blog', {
    type: 'loop',
    speed: 500,
    perPage: 1,
    perMove: 1,
    focus: 'center',
    padding: '20px',
    breakpoints: {
      480: {
        perPage: 1,
        perMove: 1
      }
    }
  }).mount();
}
// featured collection
if (document.querySelector('.slider-featured')) {
  new Splide('.slider-featured', {
    type: 'loop',
    speed: 500,
    perPage: 2,
    perMove: 1,
    breakpoints: {
      480: {
        perPage: 1,
        perMove: 1
      }
    }
  }).mount();
}
  // testimonial
if (document.querySelector('.slider_testimonial')) {
  new Splide('.slider_testimonial', {
    type: 'loop',
    speed: 500,
    perPage: 3,
    perMove: 1,
    breakpoints: {
      480: {
        perPage: 1,
        perMove: 1
      }
    }
  }).mount();
}
if (document.querySelector('.slider2_testimonial')) {
  new Splide('.slider2_testimonial', {
    focus: 'center',
    padding: '150px',
    type: 'loop',
    arrows: true,
    speed: 500,
    perPage: 2,
    perMove: 1,
    breakpoints: {
      768: {
        focus: false,
        perPage: 1,
        perMove: 1
      }
    }
  }).mount();
}
  //grain-testimonial
if (document.querySelector('.grain_testimonial')) {
  new Splide('.grain_testimonial', {
      focus: 'center',
      padding: '150px',
      type: 'loop',
      arrows: true,
      speed: 500,
      perPage: 2,
      perMove: 1,
      breakpoints: {
        768: {
          focus: false,
          perPage: 1,
          perMove: 1
        }
      }
    }).mount();
}


	// BLOGS Cards
if (document.querySelector('.blog-featured')) {
  new Splide('.blog-featured', {
    type: 'slide',
    speed: 500,
    pagination: false,
    arrows: true,
    padding: '17px',
    perPage: 4,
    perMove: 1,
    breakpoints: {
      990: {
        perPage: 2.5,
        perMove: 1,
        padding: '17px'
      },
      480: {
        perPage: 1.74,
        padding: '10px',
        perMove: 1
      }
    }
  }).mount();
}

  // ARTICLE REALTED PRODUCT CARDS
if (document.querySelector('.article-products__list')) {
  new Splide('.article-products__list', {
    type: 'slide',
    arrows: true,
    pagination: false,
    speed: 500,
    perPage: 3,
    perMove: 1,
    autoHeight: true,
    breakpoints: {
      1100: {
        perPage: 2.5,
        perMove: 1,
      },
      800: {
        perPage: 2,
        perMove: 1,
      },
      480: {
        perPage: 1.05,
        padding: '20px',
        perMove: 1
      }
    }
  }).mount();
}

if (document.querySelector('.instructions__slider-container')) {
  new Splide('.instructions__slider-container', {
    type: 'slide',
    arrows: true,
    pagination: false,
    speed: 500,
    perPage: 2.3,
    perMove: 1,
    breakpoints: {
      990: {
        perPage: 1,
        perMove: 1,
      },
      576: {
        perPage: 1.3,
        perMove: 1,
        arrows: false,
      }
    }
  }).mount();
}

});

// if(window.innerWidth >= 991 ) {
// document.addEventListener("DOMContentLoaded", function() {
//   const header = document.querySelector('.header-wrapper');
//   const mainContent = document.getElementById('MainContent');

//   if (header && mainContent) {
//     // Ensure header is rendered before calculating height
//     requestAnimationFrame(() => {
//       const headerHeight = header.getBoundingClientRect().height;
//       if (headerHeight > 0) {
//         mainContent.style.paddingTop = `${headerHeight + 20}px`;
//       }
//     });
//   }
// });
// }


class VideoSection extends HTMLElement {
  constructor() {
    super()

    this.playButton = this.querySelector(".deferred-media__poster-button");
    this.recipePlaybutton = this.querySelector('.recipe_article-play-button')
    this.isHideThumbnail = this.dataset.noThumbnail ? JSON.parse(this.dataset.noThumbnail) : false;
    this.videoContent = this.querySelector(".slurrpitup-video-content__wrapper");
    this.playButton.addEventListener("click", () => {
      this.onClickButton();
      this.cleverTapeventHandler();
    });
  }

  connectedCallback() {
    if(this.isHideThumbnail){
      setTimeout(() => {
        this.playButton?.click();
      }, 300);
    }
  } 

  onClickButton(){
    this.videoContent.classList.add('hide-video-content');
  }

  cleverTapeventHandler(){
    if (this.recipePlaybutton) {
      const articleTitle = this.playButton.getAttribute("data-article-title") || "";
      const articleHandle = this.playButton.getAttribute("data-article-handle") || "";
      const articleUrl = this.playButton.getAttribute("data-article-url") || "";
      const pageUrl = window.location.href;

      const eventData = {
        "Recipe article title": articleTitle,
        "Recipe article handle": articleHandle,
        "Recipe article url": articleUrl,
        "Recipe page url": pageUrl,
      };

        clevertap.event.push("recipe_video_played", eventData);

        console.log("recipe_video_played", eventData);
    }
  }
}
customElements.define('video-section', VideoSection);

class LazySection extends HTMLElement {
  static sectionsToFetch = [];

  constructor() {
    super();

    this.section = this.closest('section')?.id || this.closest('[id]').id;
    this.section = this.section?.replace('shopify-section-', '');

    this.trigger = this.dataset.triggerEvent || 'intersection-observer';
    this.targetSelector = this.dataset.triggerTarget || 'body';

    this.boundHandleMouseover = this.handleMouseover.bind(this);
    this.boundHandleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    const targetElement = document.querySelector(this.targetSelector);

    // Different triggers based on data-trigger attribute
    if (this.trigger === 'mouseover') {
      if (screen.width < 990) return;
      
      targetElement.addEventListener('mouseover', this.boundHandleMouseover);
    } else if (this.trigger === 'click') {
      targetElement.addEventListener('click', this.boundHandleClick);
    } else {
      // Default to intersection observer
      new IntersectionObserver(this.handleIntersection.bind(this), { rootMargin: '0px 0px 500px 0px' }).observe(this);
    }
  }

  // Handler for intersection-observer trigger
  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    this.fetchSections();
  }

  // Handler for mouseover trigger
  handleMouseover() {
    // Remove trigger once added to sectionsToFetch
    this.removeTrigger();
    this.fetchSections();
  }

  // Handler for click trigger
  handleClick() {
    // Remove trigger once added to sectionsToFetch
    this.removeTrigger();
    this.fetchSections();
  }

  // Common function for fetching sections
  fetchSections() {
    LazySection.sectionsToFetch.push(this.section);
    const sectionsToFetchBatch = LazySection.sectionsToFetch.length == 5 ? LazySection.sectionsToFetch.splice(0, 5) : LazySection.sectionsToFetch;

      // Check if there is an ongoing network request
    if (LazySection.abortController) {
      LazySection.abortController.abort('Section list updated, cancelling request.');
    }

    LazySection.abortController = sectionsToFetchBatch.length < 5 && new AbortController();

    fetch(window.location.pathname + '?sections=' + sectionsToFetchBatch.join(','), LazySection.abortController.signal ? { signal: LazySection.abortController.signal } : {})
      .then((response) => response.json())
      .then((json) => {
        for (const [key, value] of Object.entries(json)) {
          const sectionContent = new DOMParser().parseFromString(value, 'text/html').getElementById('shopify-section-' + key);

          if (sectionContent && sectionContent.innerHTML.trim().length) {
            const section = document.getElementById('shopify-section-' + key);
            
            section.innerHTML = sectionContent.innerHTML;

              // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
            section.querySelectorAll('script').forEach((oldScriptTag) => {
              const newScriptTag = document.createElement('script');
              Array.from(oldScriptTag.attributes).forEach((attribute) => {
                newScriptTag.setAttribute(attribute.name, attribute.value);
              });
              newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
              oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
            });
          }
        }

        if (sectionsToFetchBatch.length < 5)
          LazySection.sectionsToFetch = [];
      })
      .catch((e) => {
        console.warn(e);
      });
  }

  // Remove trigger based on data-target attribute
  removeTrigger() {
    const targetElement = document.querySelector(this.targetSelector);

    if (targetElement) {
      targetElement.removeEventListener('mouseover', this.boundHandleMouseover);
      targetElement.removeEventListener('click', this.boundHandleClick);
    }
  }
}

customElements.define('lazy-section', LazySection);



class productImageCarousel extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;
    this.initializeSlide();
  }

  initializeSlide() {
    if (typeof Splide === 'undefined') return;
    this.carousel = this;
    this.slider = new Splide(this.carousel, {
        type: 'slide',
        perPage: 1,
        perMove: 1,
        focus: 'left',
        pagination: true,
        arrows: true,
        drag: false,
        snap: true,
        flickMaxPages : 1,
        flickPower: 1,
        dragMinThreshold: 10,
        breakpoints: {
          750: {
            arrows: false,
            drag: true,
          },
        }
      });
      this.slider.mount();
  }
}
customElements.define('product-image-carousel', productImageCarousel);

const reviewStars = document.querySelectorAll(".review-box .jdgm-prev-badge__stars");
// const reviewCountText = document.querySelectorAll(".review-box .jdgm-prev-badge__text");
for(var z = 0; z < reviewStars.length; z++){
  var ratingCount = Math.round(reviewStars[z].getAttribute('data-score') * 10) / 10;
  reviewStars[z].innerHTML = '<svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.5 0L6.73483 3.80041H10.7308L7.49799 6.14919L8.73282 9.94959L5.5 7.60081L2.26718 9.94959L3.50201 6.14919L0.269189 3.80041H4.26517L5.5 0Z" fill="#F4C32B"/></svg>' + ratingCount;
}


document.addEventListener('click', function(e) {
  const poster = e.target.closest('.js-videoPoster');
  if (!poster) return;
  e.preventDefault();
  const wrapper = poster.closest('.js-videoWrapper');
  if (wrapper) videoPlay(wrapper);
});

function videoPlay(wrapper) {
  var iframe = wrapper.querySelector('.js-videoIframe');
  var src = iframe?.dataset?.src;
  wrapper.classList.add('videoWrapperActive');
  if (iframe && src) iframe.setAttribute('src', src);
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.addEventListener('click', function(e) {
  const subscribeBtn = e.target.closest('#home-advertisement .subscribe');
  if (!subscribeBtn) return;
  e.preventDefault();
  const footer = document.querySelector('.footer-block__newsletter');
  if (footer) {
    const top = footer.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({ top, behavior: 'smooth' });
  }
  document.getElementById('NewsletterForm--footer')?.focus({ preventScroll: true });
});

document.addEventListener('DOMContentLoaded', function() {
  var homeShoppingBtn = document.getElementById('home-shopping-btn');
  if (homeShoppingBtn) {
    homeShoppingBtn.addEventListener('click', function() {
      var target = document.getElementById('home-featured-products');
      if (target) {
        var top = target.getBoundingClientRect().top + window.pageYOffset - 100;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  }
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus?.focus();
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );

    this.input.addEventListener('change' , this.onChangeQuantity.bind(this));
  }

  onChangeQuantity(event){
    let isBundel = event.target.dataset.bundel
    let maxBundelQty = event.target.dataset.maxQuantity
    let isCollectionBundel = event.target.dataset.collectionBundel
    let maxCollectionQty = event.target.dataset.maxCollectionQuantity
    if (isBundel == 'true'  && event.target.value > maxBundelQty) {
      event.target.value = maxBundelQty
    } else if (isCollectionBundel == 'true' && event.target.value > maxCollectionQty){
      event.target.value = maxCollectionQty
    } else {
      event.target.value = event.target.value
    }
    if (event.target.value !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    const quantityInputElement = event.target;
    const templateName = quantityInputElement?.dataset?.template;
    if(templateName === 'product'){
      const productName = quantityInputElement?.dataset?.productName;
      const productUrl = quantityInputElement?.dataset?.productUrl;
      const productPricePerUnit = quantityInputElement?.dataset?.pricePerUnit;
      const updatedQuantity = parseInt(quantityInputElement.value);
      const totalPriceAfterUpdate = productPricePerUnit * updatedQuantity;
      const eventData = {
        "Product URL": productUrl,
        "Product name": productName,
        "Price per unit": productPricePerUnit,
        "new quantity": updatedQuantity,
        "total_price_after_update": totalPriceAfterUpdate
      };
      clevertap.event.push('PDP_Quantity_Changed', eventData);
    }
  }


  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    
    let isBundel = event.target.dataset.bundel
    let maxBundelQty = event.target.dataset.maxQuantity
    let isCollectionBundel = event.target.dataset.collectionBundel
    let maxCollectionQty = parseInt(event.target.dataset.maxCollectionQuantity)

    if (event.target.name === 'plus'){
      if ( (isBundel == 'true' || isCollectionBundel == 'true') && (this.input.value == maxBundelQty || this.input.value == maxCollectionQty)) {
        alert(`Sorry, you can't add more quantity.`)
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
     
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]') || event.target.closest('.mega-menu');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    const sortButton = event.target.closest('.mobile-sort-button');
    const filterButton = event.target.closest('.mobile-filter-button');
    const facetsWrapper = document.getElementById('FacetsWrapperMobile');
    const sortByDetails = document.querySelector('.Details-Mobile-SortBy');
    const activeFacetFilters = document.querySelector('#FacetFiltersFormMobile .active-facets-mobile');
    const footer = document.querySelector('.mobile-facets__footer');
    const filterAndSortHeadingEl = document?.querySelector('.mobile-facets__heading.medium-hide.large-up-hide');

    // --- New Logic (runs first) ---
    if (facetsWrapper && footer) {
      const children = [...facetsWrapper.children];

      // Footer should ALWAYS be visible
      footer.classList.remove('hidden');

      if (sortButton) {
        // For sort: hide everything except sortByDetails and footer
        children.forEach(child => {
          if (child !== sortByDetails && child.classList.contains('mobile-facets__footer') !== footer.classList.contains('mobile-facets__footer')) {
            if (!child.classList.contains('hidden')) {
              child.classList.add('hidden');
            }
          } else {
            // Ensure visible
            child.classList.remove('hidden');
          }
        });
        
        // SortBy must be visible
        sortByDetails?.classList.remove('hidden');
        footer.classList.remove('hidden');
        activeFacetFilters?.classList.add('hidden');
        filterAndSortHeadingEl.textContent = 'Sort by';
      }

      if (filterButton) {
        // For filter: sortBy should be hidden, all others shown
        children.forEach(child => {
          if (child === sortByDetails) {
            if (!child.classList.contains('hidden')) {
              child.classList.add('hidden');
            }
          } else {
            child.classList.remove('hidden');
          }
        });

        // Footer remains visible
        footer.classList.remove('hidden');
        filterAndSortHeadingEl.textContent = 'Filter';
      }
    }
    // --- Existing Functionality ---
    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header?.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
    });
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    this.querySelector('.template-popup')?.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    button?.addEventListener('click', () => {
      document.querySelector(this.getAttribute('data-modal'))?.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      window.pauseAllMedia();
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.variantUpdateInProgress = false;
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    if(this.variantUpdateInProgress) return;
    this.updateOptions();
    this.updateLabelBorder();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    window.setTimeout(() => { parent.querySelector('li.product__media-item').scrollIntoView({behavior: "smooth"}); });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      this.variantUpdateInProgress = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      this.variantUpdateInProgress = false;
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        const atcPriceEle = document.querySelector('.addtocart-total_price_container')
        if (atcPriceEle) {
          atcPriceEle.innerHTML = source.innerHTML
        }
        const discountBadge = source.querySelector('.price__badge-sale').innerHTML;
        const productDiscountBadgeEl = document.querySelector('.product-discount__badge');
        const pdpDicountEle = document.querySelector('.product-discount__badge .discount__item');
        const discountValue = parseInt(discountBadge.replace(/\D/g, ''))
        if (discountValue > 0) {
          productDiscountBadgeEl.classList.remove('hidden');
          pdpDicountEle.innerHTML = discountBadge
        } else {
          productDiscountBadgeEl.classList.add('hidden')
        }
        
        if (source && destination) destination.innerHTML = source.innerHTML;

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

        const productVariantTitle = source.querySelector('.custom-atc-variant-title').innerHTML;
        const pdpVariantTitle = document.querySelector('.custom-atc-variant-title');
        pdpVariantTitle.innerHTML = productVariantTitle;
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    const addButtonText = addButton.querySelector('.addtocart__title');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

// initilize pdp discount badge
const discountBadge = document.querySelector('.product__info-wrapper .price__badge-sale')?.innerHTML;
const productDiscountBadgeEl = document.querySelector('.product-discount__badge');
const pdpDicountEle = document.querySelector('.product-discount__badge .discount__item');
if (productDiscountBadgeEl) {
  const discountValue = parseInt(discountBadge.replace(/\D/g, ''))
  if (discountValue > 0) {
    productDiscountBadgeEl.classList.remove('hidden')
    pdpDicountEle.innerHTML = discountBadge
  }else {
    productDiscountBadgeEl.classList.add('hidden')
  }
}

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  updateLabelBorder() {
    const radios = Array.from(this.querySelectorAll('input[type="radio"]'));
    radios.forEach((radio) => {
      const label = this.querySelector(`label[for="${radio.id}"]`);
      if (radio.checked) {
        label.classList.add('checked-border');
      } else {
        label.classList.remove('checked-border');
      }
    });
  }
}

customElements.define('variant-radios', VariantRadios);

 window.productCardVariantSelects = function productCardVariantSelects() {
  /* ================================
     VARIANT CHANGE FUNCTIONALITY
  ================================== */
  const variantItems = document.querySelectorAll(".product-variants__listitem");

  variantItems.forEach(item => {
    item.addEventListener("click", function () {
      const variantListParent = this.closest(".product-variants__list");
      if (!variantListParent) return;

      // Remove 'is-selected' from siblings
      variantListParent.querySelectorAll(".is-selected").forEach(el => el.classList.remove("is-selected"));

      if (!this.classList.contains("is-selected")) {
        this.classList.add("is-selected");

        // Close dropdowns and overlay
        this.parentNode.classList.remove("show-options");
        this.parentNode.parentNode?.classList.remove("show-options");
        document.body.classList.remove("mm-no-scroll");
        document.querySelector(".mm-ajaxcart-overlay")?.classList.remove("has--active");

        // Variant attributes
        const variantId = this.dataset.id;
        const variantTitle = this.dataset.name;
        const variantWeight = this.dataset.weight;
        const variantPrice = parseFloat(this.dataset.price) || 0;
        const variantComparePrice = parseFloat(this.dataset.compareprice) || 0;
        const variantDiscount = this.dataset.discount;

        const variantProductWrapper = this.closest(".card-wrapper");
        if (!variantProductWrapper) return;

        // Hide variant and overlay
        variantProductWrapper.querySelector(".product-variants")?.classList.remove("show-variants");
        variantProductWrapper.querySelector(".product-card-overlay")?.classList.remove("show-card-overlay");

        // Update variant details
        const idInput = variantProductWrapper.querySelector('.addtocard-box input[name="id"]');
        if (idInput) idInput.value = variantId;

        const titleEl = variantProductWrapper.querySelector(".selected-variant-pack");
        if (titleEl) titleEl.textContent = variantTitle;

        const weightEl = variantProductWrapper.querySelector(".weight");
        if (weightEl) weightEl.textContent = variantWeight ? `${variantWeight} g` : "";

        const priceContainer = variantProductWrapper.querySelector(".price-custom");
        const badge = variantProductWrapper.querySelector(".badge--bottom-left");

        if (priceContainer) {
          if (variantComparePrice > 0 && variantComparePrice > variantPrice) {
            priceContainer.innerHTML = `
              <ins><span class="money" style="font-weight:600; color:black;">₹ ${variantPrice}</span></ins>
              <del><span class="money">₹ ${variantComparePrice}</span></del>`;
            if (badge) {
              badge.textContent = `${variantDiscount}% off`;
              badge.style.display = "block";
            }
          } else {
            priceContainer.innerHTML = `<ins class="ml__0" style="font-weight:600; color:black;">₹ ${variantPrice}</ins>`;
            if (badge) badge.style.display = "none";
          }
        }

        // Update add-to-cart UI asynchronously (non-blocking)
        updateCartUI(variantId, variantProductWrapper);
      }
    });
  });

  /* ================================
     VARIANT DROPDOWN TOGGLE LOGIC
  ================================== */
  const variantSelectors = document.querySelectorAll(".new-product-variant-selection");

  variantSelectors.forEach(selector => {
    selector.addEventListener("click", function () {
      const variantListParent = this.parentNode;
      const variantListWrapper = variantListParent?.querySelector(".product-variants__list");
      const cardContainer = this.closest(".card-wrapper");
      if (!variantListWrapper) return;

      // Close all other dropdowns
      document.querySelectorAll(".product-variants__list").forEach(list => list.classList.remove("show-options"));
      document.querySelectorAll(".product-variants").forEach(list => list.classList.remove("show-variants"));
      document.querySelectorAll(".product-card-overlay").forEach(overlay => overlay.classList.remove("show-card-overlay"));

      // Toggle current dropdown
      variantListParent.classList.toggle("show-variants");
      variantListWrapper.classList.toggle("show-options");

      const overlay = cardContainer?.querySelector(".product-card-overlay");
      if (overlay) {
        if (variantListWrapper.classList.contains("show-options")) {
          overlay.classList.add("show-card-overlay");
        } else {
          overlay.classList.remove("show-card-overlay");
        }
      }
    });
  });

  /* ================================
     ASYNC CART UPDATE HANDLER
  ================================== */
  async function updateCartUI(variantId, variantProductWrapper) {
    try {
      const response = await fetch("/cart.js");
      if (!response.ok) return;
      const cart = await response.json();
      const cartItem = cart.items.find(i => i.id == variantId);

      const productForm = variantProductWrapper.querySelector("product-form");
      const buttonParent = productForm?.querySelector("customaddtocart-quantity-handler");
      const addToCartBtn = productForm?.querySelector(".product-form__submit");

      if (!buttonParent || !addToCartBtn) return;

      if (cartItem) {
        addToCartBtn.style.display = "none";
        const buttonText = buttonParent.querySelector(".product-quantity__text");
        if (buttonText) {
          buttonText.textContent = `${cartItem.quantity}`;
          buttonText.dataset.cartQuantity = cartItem.quantity;
          buttonText.dataset.cartVariant = cartItem.id;
        }
        buttonParent.style.display = "flex";
      } else {
        addToCartBtn.style.display = "flex";
        buttonParent.style.display = "none";
      }
    } catch (err) {
      console.error("Cart fetch failed:", err);
    }
  }
}

if (typeof productCardVariantSelects === 'function') {
    window.productCardVariantSelects();
}

 // Display select dropdown 
  var variantSelector = document.getElementsByClassName("product-variant-selection");
  for (var variantSelector of variantSelector) {
    variantSelector.addEventListener('click', function() {
    var variantListParent = this.parentNode;
    var variantListWrapper = variantListParent.querySelector('.product-variants__list');

    if(!variantListWrapper.classList.contains('show-options')){
        document.querySelectorAll('.product-variants__list').forEach(function(e){
        e.classList.remove('is-selected');
      })
      document.querySelectorAll('.product-variants__list').forEach((each) => {
        each.classList.remove('show-options');
      })
      document.querySelectorAll('.product-variants').forEach((each) => {
        each.classList.remove('show-options');
      })
    }

    variantListParent.classList.toggle('show-options');
    variantListWrapper.classList.toggle('show-options');

      if(window.innerWidth < 749){
        document.querySelector('body').classList.toggle('mm-no-scroll');
        document.querySelector('.mm-ajaxcart-overlay').classList.toggle('has--active');
      }
    });
  }
window.onclick = function(event) {
  const selectAgeMainContainer = document.querySelector('.selected-baby-month__container') 
  if (!event.target.closest('.product-variants') && !event.target.closest('.selected-baby-month__container') && !event.target.closest('.mm-ajaxcart-open') && !event.target.closest('.mm-ajaxcart') && !event.target.closest('.slide-container')) {
    document.querySelectorAll('.product-card-overlay').forEach((eachCard)=> {
      if (eachCard.classList.contains('show-card-overlay')){
        eachCard.classList.remove('show-card-overlay')
      }
    });
    document.querySelectorAll('.product-variants').forEach((eachCard)=> {
      if (eachCard.classList.contains('show-variants')){
        eachCard.classList.remove('show-variants')
      }
    });
    document.querySelectorAll('.product-variants__list').forEach(function(e){
    e.classList.remove('show-options');
    document.querySelector('body').classList.remove('mm-no-scroll');
  })
  }  
  if (!event.target.closest('.selected-baby-month__container')) {
    selectAgeMainContainer?.classList.remove('show-age-dropdown')
    document.querySelector('body').classList.remove('mm-no-scroll');
  }
}

// close variantItems box in mobile
const variantLists = document.querySelectorAll(".product-variants__list");

variantLists.forEach((list) => {
  const closeBtn = list.querySelector(".close-button");
  const overlay = list.closest(".new-card-wrapper")?.querySelector(".product-card-overlay");

  if (closeBtn) {
    closeBtn.addEventListener("click", () => {
      list.classList.remove("show-options");
      if (overlay) overlay.style.display = "none";
    });
  }
});





/*--------------Article Share-----------*/

let shareButton = document.querySelector('.article-share__button');
let shareCloseButton = document.querySelector('.share-close__button');
let socialShareContainer = document.querySelector('.article-social__share__container');

shareButton?.addEventListener('click', () => {
  const shareData = {
    title: document.title,
    text: "Checkout this Article",
    url: window.location.href,
  };
  
  async function handleShare() {
    if (navigator.share) {
      try {
        await navigator.share(shareData);
        console.log("Article shared successfully");
      } catch (err) {
        console.error(`Error: ${err}`);
      }
    } else {
      // Fallback to showing custom share options if navigator.share is not supported
      socialShareContainer.classList.add('show-share-options');
      document.querySelector(".mm-ajaxcart-overlay").classList.add("share-option-active");
      document.querySelector("body").style.overflow = 'hidden';
    }
  }

  // Call the share function
  handleShare();

  // Passing clevertap event "blog_shared"
  const shareButtons = document.querySelectorAll(".sf-blog_article-share__button");

  if (shareButtons) {
      shareButtons.forEach(button => {
      const articleTitle = button.getAttribute("data-article-title") || "";
      const articleHandle = button.getAttribute("data-article-handle") || "";
      const articleUrl = button.getAttribute("data-article-url") || "";
      const pageUrl = window.location.href;

      const eventData = {
        "article title": articleTitle,
        "article handle": articleHandle,
        "article url": articleUrl,
        "page url": pageUrl,
      };

      clevertap.event.push("blog_shared", eventData);

      console.log("CleverTap Event Sent: blog_shared", eventData);
  });
  }

  const recipeShareButton = document.querySelectorAll(".recipe_article-share__button");

  if (recipeShareButton) {
      recipeShareButton.forEach(button => {
      const articleTitle = button.getAttribute("data-article-title") || "";
      const articleHandle = button.getAttribute("data-article-handle") || "";
      const articleUrl = button.getAttribute("data-article-url") || "";
      const pageUrl = window.location.href;

      const eventData = {
        "article title": articleTitle,
        "article handle": articleHandle,
        "article url": articleUrl,
        "page url": pageUrl,
      };

      clevertap.event.push("recipe_shared", eventData);

      console.log("recipe_shared", eventData);
  });
  }

});

shareCloseButton?.addEventListener('click', () => {
  socialShareContainer.classList.remove('show-share-options');
  document.querySelector(".mm-ajaxcart-overlay").classList.remove("share-option-active");
  document.querySelector("body").style.overflow = 'unset';
});

if (location.href.includes('/products')) {
  // In PDP Adding collection breadcrumb based on which collection user redirect to pdp page
  const collectionBreadcrumbEle = document.querySelector('.collection-breadcrumb')
  const collectionBreadcrumb = collectionBreadcrumbEle.querySelector('a')

  if (!document.referrer.includes('collection')){
    sessionStorage.setItem('collectionName', null);
    sessionStorage.setItem('collectionUrl', null);
    collectionBreadcrumbEle.classList.add('hidden');
  }

  const breadcrumbUrl = sessionStorage.getItem('collectionUrl');
  const breadcrumbTitle = sessionStorage.getItem('collectionName');

  if (document.referrer.includes('collection')){
    const collectionUrl = document.referrer

    // Split the URL by "/"
    const urlParts = collectionUrl.split("/");
    const collectionName = ((urlParts.pop()).split('?').shift()).replace("-", " ")

    sessionStorage.setItem('collectionName', collectionName);
    sessionStorage.setItem('collectionUrl', collectionUrl);

    const collectionBreadcrumbUrl = sessionStorage.getItem('collectionUrl');
    const collectionBreadcrumbTitle = sessionStorage.getItem('collectionName');

    collectionBreadcrumbEle.classList.remove('hidden');
    collectionBreadcrumb.href = collectionBreadcrumbUrl
    collectionBreadcrumb.textContent = collectionBreadcrumbTitle
  } else if (breadcrumbUrl !== 'null' || breadcrumbTitle !== 'null') {
    collectionBreadcrumbEle.classList.remove('hidden');
    collectionBreadcrumb.href = breadcrumbUrl
    collectionBreadcrumb.textContent = breadcrumbTitle
  } else {
    collectionBreadcrumbEle.classList.add('hidden');
  }
}

// slurrpitup landing page banner splide initialization
const siuLandingPageBannerEl = document.querySelector('.slurrpitup-banner-container.splide');
if (siuLandingPageBannerEl && !siuLandingPageBannerEl.__splideMounted) {
  const splide = new Splide(siuLandingPageBannerEl);
  splide.mount();
  siuLandingPageBannerEl.__splideMounted = true;
}

class CustomDatePicker extends HTMLElement {
  constructor() {
    super();
    this.dateInput = this.querySelector("input");
  }

  connectedCallback() {
    this.dateInput.addEventListener("click", () => {
      if (this.dateInput.showPicker) {
        this.dateInput.showPicker();
      } else {
        this.dateInput.focus();
      }
    });
  }
}

customElements.define("custom-date-picker", CustomDatePicker);

function handleInternationalWalletCTAClick(event, element) {
  event.preventDefault();
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const userLoggedIn = element?.dataset?.userLoggedIn;
      const eventData = {
        "Total quantity": cart.item_count,
        "Total price": cart.total_price / 100,
        "User logged in": userLoggedIn
      };
      clevertap.event.push('International_Wallet_CTA_clicked', eventData);
      window.location.href = element.href;
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
      window.location.href = element.href;
    });
}

class ReadMoreDescription extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.description = this.querySelector('.product__description-container');
    this.button = this.querySelector('.description_read-more-btn');
    this.textSpan = this.button?.querySelector('.text');
    this.arrowIcon = this.button?.querySelector('svg');

    if (!this.description || !this.button) return;

    // Check if content is clamped
    const clone = this.description.cloneNode(true);
    Object.assign(clone.style, {
      visibility: 'hidden',
      position: 'absolute',
      height: 'auto',
      webkitLineClamp: 'unset',
      display: 'block',
    });
    document.body.appendChild(clone);

    const isClamped = clone.offsetHeight > this.description.offsetHeight;
    document.body.removeChild(clone);

    if (!isClamped) {
      this.button.style.display = 'none';
    }else {
      this.button.setAttribute('aria-expanded', 'false');
      this.description.setAttribute('aria-expanded', 'false');
    }

    this.button.addEventListener('click', () => {
      const isExpanded = this.description.classList.toggle('expanded');
      this.button.classList.toggle('expanded', isExpanded);
      this.textSpan.textContent = isExpanded ? 'Read less' : 'Read more';
      this.button.setAttribute('aria-expanded', isExpanded);
      this.description.setAttribute('aria-expanded', isExpanded);
    });
  }
}

customElements.define('read-more-description', ReadMoreDescription);

class BulkOrderThankYou extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    document.querySelector('body')?.classList.add('overflow-hidden');
    const bulkOrderRedirectionUrl = this.dataset.redirectionUrl;
    let submittedBulkOrderFormData = null;

    try {
      const rawData = sessionStorage.getItem('bulkOrderFormData');
      if (rawData) {
        submittedBulkOrderFormData = JSON.parse(rawData);
      }
    } catch (error) {
      console.error('Failed to parse bulk order form data:', error);
    }

    if (submittedBulkOrderFormData) {
      if (typeof fbq === 'function') {
        fbq('trackCustom', 'Bulk-Form-filled-new', submittedBulkOrderFormData);
      }

      if (bulkOrderRedirectionUrl) {
        setTimeout(() => {
          window.location.href = bulkOrderRedirectionUrl;
        }, 3000);
      }
    }
  }
}

customElements.define('bulk-order-thank-you', BulkOrderThankYou);

// This code is used to listen for the Gokwik side cart events and update the cart data accordingly
window.addEventListener('message', event => {
  if (event.origin !== window.location.origin) {
    return;
  }
  if(event.data.name === 'quantity_change'){
    if (!event.data.body || typeof event.data.body !== 'object') {
      console.error('Invalid quantity_change message structure');
      return;
    }
    const variantId = event.data.body.id;
    const quantity = event.data.body.quantity;
    if (!variantId || typeof quantity !== 'number' || quantity < 0) {
      console.error('Invalid quantity_change message data');
      return;
    }
    document.dispatchEvent(new CustomEvent('cartDataUpdate', {
      detail: {
        variant: variantId,
        quantity: quantity
      }
    }));
  }
});



class InfinitePageLoader extends HTMLElement {
  constructor() {
    super();

    this.sectionID = this.dataset.section || document.querySelector('infinite-page-loader')?.dataset.section || ''
    this.collectionInnerElement = document.querySelector('#product-grid')
    this.saveScrollPoint();
    this.restoreScrollPoint();
  }

  connectedCallback() {
    this.init()
  }

  init() {
    this.addObserver();
  }

  addObserver() {
    const observer = new window.IntersectionObserver(([entry]) => {

      if (entry.isIntersecting) {          
          if (entry.target == this.loadActivatorElem)
            observer.disconnect();

          var nextPageUrl = this.getNextPageUrl()

          if (nextPageUrl)
            this.loadProducts(nextPageUrl)
        }

    }, {
      root: null,
      threshold: 0.1
    })
      
    observer.observe(this)
  }

  getNextPageUrl() {
    var nextPage = parseInt(this.dataset.currentpage) + 1;

    if (nextPage > this.dataset.totalpages) {
      return false
    }

    return this.constructURLWithSearchParams(nextPage)
  }

  constructURLWithSearchParams(page) {
    var params = new URLSearchParams(document.location.search)
    var nextPage = parseInt(page) || parseInt(this.dataset.currentpage) + 1;
    var pageParam = this.dataset.pageParam || 'page'

    params.set(pageParam, nextPage)
    // params.set('filter.v.availability', 1) // To set the available products by default
    
    var searchParamsAsString = params.toString() 

    return "".concat(window.location.pathname, "?").concat(searchParamsAsString)
  }

  updateCurrentURL(url) {
    if (history.replaceState) {
      window.history.pushState({
        path: url
      }, '', url);
    }
  }

  loadProducts(url) {
    if (this.classList.contains('loading')) return;

    this.classList.add('loading')
    this.querySelector('div').classList.remove('hidden')

    this.getAndInsertHtml(url, 'append')
  }

  getAndInsertHtml(url, insertPosition) {
    var _this4 = this;

    if (this.abortController) {
      this.abortController.abort();
    }
    var currentUrl = new URL(url, window.location.href);
    currentUrl.searchParams.set('section_id', this.sectionID);

    try {
      this.abortController = new AbortController();

      fetch(currentUrl.toString(), {
        signal: this.abortController.signal
      }).then(function (response) {
        response.text().then(function (content) {
          var tempElement = new DOMParser().parseFromString(content, "text/html");

          if (insertPosition == 'append') {
            _this4.collectionInnerElement.innerHTML += tempElement.querySelector('#product-grid').innerHTML; //Appending new sets of product cards
            _this4.dataset.currentpage = tempElement.querySelector('infinite-page-loader').dataset.currentpage
            _this4.dataset.totalpages = tempElement.querySelector('infinite-page-loader').dataset.totalpages
          }
          else if (insertPosition == 'prepend')  {
            _this4.collectionInnerElement.insertAdjacentHTML('afterbegin', tempElement.querySelector('#product-grid').innerHTML);
            _this4.dataset.currentpage = tempElement.querySelector('load-previous-page').dataset.currentpage
          }
          
          _this4.init();
          window.productCardVariantSelects();
          _this4.saveScrollPoint();

          _this4.classList.remove('loading')
          _this4.querySelector('div').classList.add('hidden')
        });
      });
    } catch (exception) {}
  }

  saveScrollPoint() {
      let productCards = document.querySelectorAll("marmeto-product-card");
  
      productCards.forEach((productCard) => {
        const observer = new IntersectionObserver((entries) => {
            observerCallback(entries, observer, productCard)
        },
        {threshold: 0.7});    
        observer.observe(productCard); // Observing each product card that is visible

         productCard.addEventListener('click', () => {
          sessionStorage.setItem("lastElementId", productCard.id);  
        });
      })
    
      const observerCallback = (entries, observer, header) => {
        entries.forEach((entry, i) => {
          if (entry.isIntersecting && entry.target.dataset.page) {
              this.updateCurrentURL(this.constructURLWithSearchParams(entry.target.dataset.page)) //updating the url depending on the product viewed
          }
        });
      };
  }

  restoreScrollPoint() {
    // Returning if browser is safari as it gets scrolled to top after scrollIntoView method is used.
    if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) return;
    
    history.scrollRestoration = "manual";
    // Reverting back to the previous element that was being viewed. 
    window.onload = function() {
      var lastElementId = sessionStorage.getItem("lastElementId");
      var lastElement = document.getElementById(lastElementId);

      if (lastElement) 
          lastElement.scrollIntoView();
          
      sessionStorage.removeItem('lastElementId'); 
    };
  }
}

customElements.define('infinite-page-loader', InfinitePageLoader);

class LoadPreviousPage extends InfinitePageLoader {
  constructor() {
    super();

    this.addEventListener('click', this.loadProducts.bind(this));
  }

  connectedCallback() {
    this.init()
  }

  init() {
    var infinitePageLoader = document.querySelector('infinite-page-loader') 
    var maxPagesLoadable = this.dataset.totalpages - 1;

    if (infinitePageLoader.dataset.currentpage - this.dataset.currentpage == maxPagesLoadable //when all the pages are loaded
      || this.dataset.currentpage == 1) { // When user is at page 1
        this.classList.add('hidden')
    } else {
      this.classList.remove('hidden')
    }
  }

  loadProducts() {
    if (this.classList.contains('loading')) return;
    
    var prevPageUrl = this.getPrevPageUrl()

    if (prevPageUrl) {
      this.classList.add('loading')
      this.getAndInsertHtml(prevPageUrl, 'prepend')
    }
  }

  getPrevPageUrl() {
    var prevPage = parseInt(this.dataset.currentpage) - 1;

    if (prevPage < 1) {
      return false
    }

    return this.constructURLWithSearchParams(prevPage)
  }
}

customElements.define('load-previous-page', LoadPreviousPage);


// Snowfalkes animation

(function () {
  const canvas = document.getElementById("snow-canvas");
  if (canvas) {
    const ctx = canvas.getContext("2d");

    let width = canvas.width = window.innerWidth;
    let height = canvas.height = window.innerHeight;

    const snowflakes = [];

    function createSnowflake() {
      return {
        x: Math.random() * width,
        y: Math.random() * height,

        // Small snowballs
        radius: Math.random() * 2 + 0.5,

        // Faster fall
        speed: Math.random() * 2 + 1.5,

        // Stronger base wind for slanted fall
        wind: Math.random() * 2 - 1,

        // Horizontal oscillation amplitude
        oscillation: Math.random() * 0.8 + 0.2,

        // Random phase for natural staggering
        angle: Math.random() * Math.PI * 2
      };
    }

    function initSnowflakes() {
      // Increase frequency → previously 150, now 300
      for (let i = 0; i < 300; i++) {
        snowflakes.push(createSnowflake());
      }
    }

    function updateSnowflakes() {
      for (let flake of snowflakes) {
        flake.y += flake.speed;

        // Much stronger oscillation effect
        flake.angle += 0.04; // ~wave speed
        flake.x += Math.sin(flake.angle) * flake.oscillation;

        // Also keep the base slanted wind
        flake.x += flake.wind * 0.3;

        // Respawn conditions
        if (flake.y > height) flake.y = -flake.radius;
        if (flake.x > width) flake.x = 0;
        if (flake.x < 0) flake.x = width;
      }
    }

    function drawSnowflakes() {
      ctx.clearRect(0, 0, width, height);
      ctx.fillStyle = "white";

      for (let flake of snowflakes) {
        ctx.beginPath();
        ctx.arc(flake.x, flake.y, flake.radius, 0, Math.PI * 2);
        ctx.fill();
      }
    }

    function animate() {
      updateSnowflakes();
      drawSnowflakes();
      requestAnimationFrame(animate);
    }

    window.addEventListener("resize", () => {
      width = canvas.width = window.innerWidth;
      height = canvas.height = window.innerHeight;
    });

    initSnowflakes();
    animate();
  }
})();